module.exports = __webpack_public_path__ + "static/img/image77.045e41a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c34/image77.png
// module id = l1aJ
// module chunks = 0